<template>
  <v-container>
    <v-data-table
      :items="orders"
      item-key="orderNumber"
      :loading="loading"
      :search="search"
      :headers="headers"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      must-sort
    >
      <template v-slot:top>
        <v-row no-gutters align="center" class="pa-3">
          <v-text-field
            label="Search"
            v-model="search"
            append-icon="mdi-magnify"
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn fab x-small color="primary" @click="refreshOrders">
            <v-icon dark>mdi-refresh</v-icon>
          </v-btn>
        </v-row>
      </template>
      <template v-slot:[`item.openedOn`]="{ item }">
        {{ item.openedOn | moment("MM/DD/YYYY") }}
      </template>
      <template v-slot:[`item.address`]="{ item }">
        {{ `${item.address},`
        }}<span v-if="item.address2">{{ `${item.address2},` }}</span>
        {{ `${item.city}, ${item.state} ${item.zip}` }}
      </template>
      <template v-slot:[`item.details`]="{ item }">
        <v-btn
          color="primary"
          small
          :to="`/dashboard/orders/${item.orderNumber}`"
          >Details
        </v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "OrderHistory",
  mounted() {
    this.updateWindowTitle({ newTitle: "Order History" });
    this.refreshOrders()
  },
  data: () => {
    return {
      loading: false,
      search: "",
      sortBy: "openedOn",
      sortDesc: true,
      headers: [
        { text: "Date", value: "openedOn" },
        { text: "Address", value: "address" },
        { text: "Status", value: "status" },
        { text: "Order Number", value: "orderNumber" },
        { text: "", value: "details", sortable: false, align: "right" },
      ],
    };
  },
  computed: {
    orders() {
      return this.$store.state.orders.orders;
    },
  },
  methods: {
    ...mapActions(["updateWindowTitle"]),
    ...mapActions("orders", ["updateOrders"]),
    refreshOrders() {
      this.loading = true;
      this.updateOrders()
        .then(() => (this.loading = false))
        .catch(() => (this.loading = false));
    },
  },
};
</script>
